import routerOptions0 from "/codebuild/output/src947570429/src/nuxt-skupinaklik/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.1_@types+node@22.13.10_db0@0.3.1_eslint@8.29.0_ioredis@5.6._l32r6ss2ikf5flxnsyfeie6rim/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}